import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Alert, Badge, Box, Button, Checkbox, Container, ExpandableSection, Form, FormField, Input, Link, List, Modal, RadioGroup, Select, SpaceBetween, StatusIndicator, Table, Tabs, Textarea, TimeInput } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiArrowUpRightBold, mdiDeleteOutline, mdiNoteEditOutline, mdiPencilOffOutline, mdiPlus, mdiProgressQuestion } from '@mdi/js';
import { Icon } from '@mdi/react';
import DPModal from '../../../../../components/DPModal';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import ConfirmDelete from '../../../../../components/extras/ConfirmDelete';
import Favorites from '../../../../../components/extras/Favorites';
import { Spacer } from '../../../../../components/extras/Spacer';
import SelectGroup from '../../../../../components/selects/selectGroups';
import SelectUserType from '../../../../../components/selects/selectUserTypes';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnDanger, btnWarn, ItemPoll, ItemPollQuestion } from '../../../../../resources/types';
import { addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, scrollToTop, setData, setLoading } from '../../../../commons/functions';


///private/admin/polls/update

export const CommPollsEditPage = () => {
  //const storeAdmin = useStoreAdmin();

  const { menu, data } = useGlobalState();



  const [polls, setPolls] = useState<ItemPoll[]>([]);
  const [questions, setQuestions] = useState<ItemPollQuestion[]>([]);
  const [question, setQuestion] = useState<ItemPollQuestion>();
  const [deleteQuestion, setDeleteQuestion] = useState<ItemPollQuestion>();
  const [idPoll, setIdPoll] = useState<number>(0);
  const [d1, setD1] = useState<boolean>(false);
  const [d2, setD2] = useState<boolean>(false);
  const [poll, setPoll] = useState<ItemPoll | null>(null);
  const [pollDelete, setPollDelete] = useState<ItemPoll | null>(null);


  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");
      if (id) handleGetPoll(id ? parseInt(id) : 0);
      else {
        handleGetPolls()
      }
    };

    window.addEventListener("hashchange", handleHashChange);
    // also trigger once on mount
    handleHashChange();

    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);
  const handleAddQuestion = (question: any) => {
    if (!question || !poll) return;
    let updatedQuestions;
    const exists = poll.questions.some((q: any) => q.idQuestion !== 0 && q.idQuestion === question.idQuestion);

    if (exists) {
      updatedQuestions = poll.questions.map((q: any) =>
        q.idQuestion === question.idQuestion ? { ...question } : q
      );
    } else {
      updatedQuestions = [...poll.questions, { ...question }];
    }
    const nextPoll = {
      idPoll: poll.idPoll,
      questions: updatedQuestions
    };
    //setPoll(nextPoll);
    handleUpdatePollManual(nextPoll);
  };
  const handleAddQuestion2 = (question: any) => {

    const updatedQuestions = [...poll.questions, question];
    const nextPoll = {
      idPoll: poll.idPoll,       // Solo mantenemos el ID
      questions: updatedQuestions // Y el array de preguntas nuevo
    };
    //setPoll(nextPoll);
    handleUpdatePollManual(nextPoll);
  }
  const handlePollDelete = async () => {
    setPoll(null)
    try {
      setLoading(true);


      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/polls/delete.poll',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify(pollDelete)
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data.code === 0) {
        setPollDelete(null)
        setPoll(null)
        window.location.hash = "#comm/polls/edit"
        if (data && data.polls) {
          //setPolls(data.polls);
        }
      }

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  }
  const handleGetPolls = async () => {
    setPoll(null)
    try {
      setLoading(true);


      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/polls/list',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify({
          orderBy: "dateOpen",
          order: "desc",
          orderBy2: "dateStart",
          order2: "asc"
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data && data.polls) {
        setPolls(data.polls);
      }

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  }


  const handleGetPoll = async (idPoll: number) => {
    try {
      if (idPoll && idPoll > 0) {
        setLoading(true);


        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/admin/polls/get',
            'JWT': getCookie("JWT"),

          },
          body: JSON.stringify({ idPoll: idPoll })
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }

        const data = await response.json();
        if (data && data.poll) {
          const questionsWithExpanded = data.poll.questions.map((question: ItemPollQuestion) => ({
            ...question,
            expanded: false
          }));

          // 2. Update Poll with the updated questions
          setPoll({
            ...data.poll,
            questions: questionsWithExpanded
          });

          //setPoll(data.poll);
          data.poll.questions.map((question: ItemPollQuestion) => {
            // Create a copy of the question with the added key
            let q = { ...question, expanded: false };
            setQuestions((prevQuestions) => [...prevQuestions, q]);
          });
        }

      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
  }, []);
  const handleUpdatePollManual = async (poll: any, silent: boolean = false) => {
    try {
      if (poll) {
        if (!silent) setLoading(true);
        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/admin/polls/update',
            'JWT': getCookie("JWT"),

          },
          body: JSON.stringify(poll)
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }

        const data = await response.json();

        if (!silent) addNotificationStatus(data, setData);
        if (data) {
          if (data.poll) {

            setPoll(data.poll)
            setQuestion(undefined)
          }
        }
      }

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleUpdatePoll = async () => {
    try {
      if (poll) {
        console.log(poll.dateStart + " " + (poll.timeStart === "" ? "12:00" : poll.timeStart))
        let body: any = {
          idPoll: poll.idPoll,
          poll: poll.poll,
          description: poll.description,
          isActivePoll: poll.isActivePoll,
          dateStart: poll.dateStart + " " + (poll.timeStart === "" ? "12:00" : poll.timeStart),
          dateOpen: poll.dateOpen + " " + (poll.timeOpen === "" ? "12:00" : poll.timeOpen),
          dateClose: poll.dateClose + " " + (poll.timeClose === "" ? "12:59" : poll.timeClose),
          publicResults: poll.publicResults,
          publicAnswers: poll.publicAnswers,
          liveResults: poll.liveResults ?? 0,
          maxAllowance: poll.maxAllowance,
          idUserTypes: poll.idUserTypes,
          idUserGroups: poll.idUserGroups,
          questions: poll.questions,
          visibility: poll.visibility,
          pollType: poll.pollType,
          showOnHome: poll.showOnHome,
          userCanDeleteRegistration: poll.userCanDeleteRegistration,
        }

        if (pollIsDisableEdit) {
          const { description, poll: pollTitle, dateStart, dateOpen, dateClose, questions, pollType, ...cleanBody } = body;
          body = cleanBody;
        }
        setLoading(true);

        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/admin/polls/update',
            'JWT': getCookie("JWT"),

          },
          body: JSON.stringify(body)
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }

        const data = await response.json();
        addNotificationStatus(data, setData);

        if (data) {
          scrollToTop();

        }
      }

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };
  const pollTypes = [
    { value: "POLL", label: "Encuesta" },
    { value: "INSCRIPTION", label: "Inscripción" },
    { value: "REGISTRATION", label: "Registro" },
    { value: "VOTING", label: "Votación" },
  ]
  const handleDeleteQuestion = async (idQuestion: number) => {
    try {
      if (poll) {
        setLoading(true);

        let body = {
          idPoll: poll.idPoll,
          idQuestion: idQuestion
        }

        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/admin/polls/delete.question',
            'JWT': getCookie("JWT"),

          },
          body: JSON.stringify(body)
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }

        const data = await response.json();

        if (data) {
          setDeleteQuestion(undefined)
          if (data.poll)
            setPoll(data.poll)
        }
      }

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {


    if (!poll) {
      setD1(true);
      setD2(true);
      return;
    }

    if (poll.publicAnswers === 0) {
      setPoll({ ...poll, publicResults: 0, liveResults: 0 })
      setD1(true);
      setD2(true);
      //return;
    } else {

      if (poll.publicResults === 0) {
        setPoll({ ...poll, liveResults: 0 })
        setD1(false);
        setD2(true);
        // return;
      } else {
        setD1(false);
        setD2(false);
      }
    }
  }, [poll]);
  const pollIsDisableEdit = (!poll || poll?.hasEnded === 1 || (poll.answers && poll.answers.length > 0));
  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          {!poll && (
            <>
              <Header variant="h1" actions={<>{!poll ? <Button variant="primary"
                onClick={() =>

                  setPoll((prev) => ({
                    ...prev!,
                    idPoll: 0,
                    isActivePoll: 0,
                    poll: "Nueva Inscripción",
                    idGroups: [],
                    idUserTypes: [],
                    description: "",
                    dateStart: "",
                    dateEnd: "",
                    dateOpen: "",
                    dateClose: "",
                    publicResults: 0,
                    publicAnswers: 0,
                    maxAllowance: 1,
                    visibility: 1,
                    questions: [],
                  }))
                }
              >Crear</Button> : ""}{poll ? <Button variant='link' onClick={() => {
                setPoll(null)
                handleGetPolls()
              }}>Volver</Button> : ""}<Favorites /></>}>Inscripciones</Header>
              <Table items={polls}
                variant='embedded'
                columnDefinitions={[
                  {
                    id: 'poll', header: 'Inscripción', cell: (item) =>
                      <FormField label={
                        <Link href={"#comm/polls/edit?id=" + item.idPoll.toString()}>{item.poll}</Link>
                      }>

                      </FormField>

                  },
                  {
                    id: 'Publicacióon', header: 'Inicio', cell: (item) =>
                      <FormField label={item.dateStart}>
                        <Box variant="awsui-key-label">{item.timeStart}</Box>
                      </FormField>,
                    minWidth: 100
                  },
                  {
                    id: 'dateStart', header: 'Apertura', cell: (item) =>
                      <FormField label={item.dateOpen}>
                        <Box variant="awsui-key-label">{item.timeOpen}</Box>
                      </FormField>,
                    minWidth: 100
                  },
                  {
                    id: 'dateEnd', header: 'Cierre', cell: (item) =>

                      <FormField label={item.dateClose}>
                        <Box variant="awsui-key-label">{item.timeClose}</Box>
                      </FormField>,
                    minWidth: 100
                  },
                  {
                    id: 'status', header: '', cell: (item) =>
                      item.isActivePoll === 0 ? <BadgeCustom color="red" fullWidth>Inactiva</BadgeCustom> :
                        item.hasStarted === 0 ? <BadgeCustom color="light" fullWidth>No iniciada</BadgeCustom> :
                          item.hasEnded === 1 ? <BadgeCustom color="blue" fullWidth>Finalizada</BadgeCustom> :
                            <BadgeCustom color="green" fullWidth>Activa</BadgeCustom>

                    ,
                    maxWidth: 100
                  },
                ]} />
            </>
          )}
          {poll && (
            <>
              <Header variant="h2"
                description={poll?.idPoll !== 0 ? poll.poll : undefined}
                actions={
                  <Button variant="link" onClick={() => {
                    setPoll(null); window.location.href = "#comm/polls/edit"
                  }}>Cancelar</Button>}>{poll.idPoll === 0 ? "Crear inscripción" : "Editar inscripción"}</Header>
              <SpaceBetween size="s" direction='vertical'>
                {(poll.hasEnded === 1) && (
                  <Alert type="info" header={`La inscripción no puede ser modificada porque ya ha ${poll.hasEnded === 1 ? "finalizado" : "comenzado"}.`} dismissible={false} />
                )}
                {(poll.answers && poll.answers.length > 0) && (
                  <Alert type="info" header={`La inscripción no puede ser modificada porque contiene ya ${poll.answers.length} respuesta${poll.answers.length > 1 ? "s" : ""}.`} dismissible={false} />
                )}

                <Tabs
                  key="POLL"
                  tabs={[
                    {
                      label: "Inscripción",
                      id: "POLL",
                      content: (
                        <SpaceBetween size="s" direction='vertical'>
                          <Form>

                            <SpaceBetween size="xs" direction='vertical'>
                              <Container header={<Header>Información</Header>}>
                                <SpaceBetween size="xs" direction='vertical'>

                                  <FormField label="Título de la inscripción" info={pollIsDisableEdit ? <Icon path={mdiPencilOffOutline} size={0.75} color="gray" /> : null}>
                                    <Input readOnly={pollIsDisableEdit} value={poll.poll} onChange={(e) => setPoll({ ...poll, poll: e.detail.value })} placeholder="Titulo de la inscripción" />
                                  </FormField>
                                  {poll.emailSent === "" && (
                                    <StatusIndicator type="pending">
                                      Correo de notificación será enviado en la fecha y hora de publicación
                                    </StatusIndicator>
                                  )}
                                  {poll.emailSent !== "" && poll.hasStarted === 1 && (
                                    <StatusIndicator type="success">
                                      Correo de notificación fue enviado el {poll.emailSent}{" "}<Link>Enviar nuevamente</Link>
                                    </StatusIndicator>
                                  )}
                                  <FormField label="Descripción de la inscripción" info={pollIsDisableEdit ? <Icon path={mdiPencilOffOutline} size={0.75} color="gray" /> : null}>
                                    <Textarea readOnly={pollIsDisableEdit} rows={5} value={poll.description} onChange={(e) => setPoll({ ...poll, description: e.detail.value })} placeholder="Descripción de la inscripción" />
                                  </FormField>
                                </SpaceBetween>

                              </Container>
                              <Container header={<Header>Fechas</Header>}>
                                <SpaceBetween size="xs" direction='vertical'>
                                  <div style={{ width: 320 }}>
                                    <FormField label="Publicación" info={pollIsDisableEdit ? <Icon path={mdiPencilOffOutline} size={0.75} color="gray" /> : null} constraintText="Fecha y hora en que la inscripción será visible para los usuarios">
                                      <SpaceBetween size="xs" direction='horizontal'>
                                        <DPModal readonly={pollIsDisableEdit} date={poll?.dateStart} onConfirm={(date) => {
                                          if (date && date !== "")
                                            setPoll({ ...poll, dateStart: date });
                                        }} />
                                        <div style={{ width: 80 }}>
                                          <TimeInput readOnly={pollIsDisableEdit} autoComplete={false} format="hh:mm" value={poll?.timeStart} onChange={({ detail }) => setPoll({ ...poll, timeStart: detail.value })} />
                                        </div>
                                      </SpaceBetween>
                                    </FormField>
                                  </div>
                                  <div style={{ width: 320 }}>
                                    <FormField label="Apertura" info={pollIsDisableEdit ? <Icon path={mdiPencilOffOutline} size={0.75} color="gray" /> : null} constraintText="Fecha en que los usuarios pueden comenzar a votar">
                                      <SpaceBetween size="xs" direction='horizontal'>
                                        <DPModal readonly={pollIsDisableEdit} date={poll?.dateOpen} onConfirm={(date) => {
                                          if (date && date !== "")
                                            setPoll({ ...poll, dateOpen: date });
                                        }} />

                                        <div style={{ width: 80 }}>
                                          <TimeInput readOnly={pollIsDisableEdit} autoComplete={false} format="hh:mm" value={poll?.timeOpen} onChange={({ detail }) => setPoll({ ...poll, timeOpen: detail.value })} />
                                        </div>
                                      </SpaceBetween>
                                    </FormField>
                                  </div>
                                  <div style={{ width: 320 }}>
                                    <FormField label="Cierre" constraintText="Fecha en que los usuarios ya no pueden votar" info={pollIsDisableEdit ? <Icon path={mdiPencilOffOutline} size={0.75} color="gray" /> : null}>
                                      <SpaceBetween size="xs" direction='horizontal'>
                                        <DPModal readonly={pollIsDisableEdit} date={poll?.dateClose} onConfirm={(date) => {
                                          if (date && date !== "")
                                            setPoll({ ...poll, dateClose: date });
                                        }} />

                                        <div style={{ width: 80 }}>
                                          <TimeInput readOnly={pollIsDisableEdit} autoComplete={false} format="hh:mm" value={poll?.timeClose} onChange={({ detail }) => setPoll({ ...poll, timeClose: detail.value })} />
                                        </div>
                                      </SpaceBetween>
                                    </FormField>
                                  </div>

                                </SpaceBetween>
                              </Container>
                              <Container header={<Header>Visibilidad</Header>}>
                                <SpaceBetween size="xs" direction='vertical'>
                                  <FormField label="Tipo de registro" info={pollIsDisableEdit ? <Icon path={mdiPencilOffOutline} size={0.75} color="gray" /> : null}>
                                    <Select readOnly={pollIsDisableEdit} selectedOption={pollTypes.find((option) => option.value === poll.pollType)} onChange={({ detail }) => setPoll({ ...poll, pollType: detail.selectedOption.value })}
                                      options={pollTypes}
                                    />

                                  </FormField>

                                  <Checkbox description="Registro se encuentra activo para ser visualizada" checked={poll.isActivePoll === 1} onChange={(e) => setPoll({ ...poll, isActivePoll: e.detail.checked ? 1 : 0 })}>Activa</Checkbox>


                                  <Checkbox description="Registro se publica en el HOME de la intranet" checked={poll.showOnHome === 1} onChange={(e) => setPoll({ ...poll, showOnHome: e.detail.checked ? 1 : 0 })}>Mostrar en HOME</Checkbox>

                                  <Checkbox description="Usuario puede eliminar su inscripción antes del cierre" checked={poll.userCanDeleteRegistration === 1} onChange={(e) => setPoll({ ...poll, userCanDeleteRegistration: e.detail.checked ? 1 : 0 })}>Eliminar registro</Checkbox>

                                  <FormField label="Visibilidad del registrado" constraintText="Define si la lista de registrados es visible al público en general">
                                    <RadioGroup
                                      direction='horizontal'
                                      value={poll.visibility.toString()} onChange={(e) => setPoll({ ...poll, visibility: parseInt(e.detail.value) })}
                                      items={[
                                        { value: "1", label: "Público" },
                                        { value: "-1", label: "Privado" },
                                      ]} />
                                  </FormField>

                                  <Checkbox description="Respuestas pueden ser visualizados de manera pública" checked={poll.publicAnswers === 1} onChange={(e) => setPoll({ ...poll, publicAnswers: e.detail.checked ? 1 : 0 })}>Respuestas públicas</Checkbox>

                                  <Checkbox disabled={d1} description="Resultados pueden ser visualizados de manera pública" checked={poll.publicResults === 1} onChange={(e) => setPoll({ ...poll, publicResults: e.detail.checked ? 1 : 0 })}>Resultados públicos</Checkbox>

                                  <Checkbox disabled={d2} description="Resultados disponibles antes del cierre (Durante el transcurso en cuanto el registro se encuentra activo para inscribirse)" checked={poll.liveResults === 1} onChange={(e) => setPoll({ ...poll, liveResults: e.detail.checked ? 1 : 0 })}>Previsualización de resultados</Checkbox>


                                </SpaceBetween>
                              </Container>

                              <Container header={<Header>Target de usuarios</Header>}>
                                <SpaceBetween size="xs" direction='horizontal'>
                                  <div style={{ width: 250 }}>
                                    <FormField label="Tipos de usuarios" info={pollIsDisableEdit ? <Icon path={mdiPencilOffOutline} size={0.75} color="gray" /> : null} stretch>
                                      <SelectUserType readonly={pollIsDisableEdit} single={false} value={poll.idUserTypes} onSelect={(userTypeIds: number[]) => setPoll({ ...poll, idUserTypes: userTypeIds })} tokenLimit={0} />
                                    </FormField>
                                  </div>
                                  <div style={{ width: 250 }}>
                                    <FormField label="Grupos de usuarios" info={pollIsDisableEdit ? <Icon path={mdiPencilOffOutline} size={0.75} color="gray" /> : null} stretch>
                                      <SelectGroup
                                        readonly={pollIsDisableEdit}
                                        single={false} value={poll.idUserGroups} onSelect={(groupIds: number[]) => setPoll({ ...poll, idUserGroups: groupIds })} tokenLimit={0} />
                                    </FormField>
                                  </div>
                                </SpaceBetween>
                              </Container>

                            </SpaceBetween>
                          </Form>
                          <Box>
                            <Box float="left">
                              {poll.idPoll > 0 && (
                                <Button style={{ root: btnWarn }}
                                  disabled={poll.hasStarted === 1 || (poll.answers && poll.answers.length > 0)}
                                  onClick={() => {
                                    setPollDelete(poll);
                                  }}>Eliminar</Button>
                              )}
                            </Box>
                            <Box float="right">
                              <Button variant="primary"
                                disabled={poll.hasEnded === 1}
                                onClick={() => {
                                  handleUpdatePoll()
                                }}>{poll.idPoll === 0 ? "Crear" : "Actualizar"}</Button>
                            </Box>

                          </Box>

                        </SpaceBetween>

                      )
                    },
                    {
                      label: "Preguntas",
                      action: (

                        poll.questions.length > 0 ? (<Badge>{poll.questions.length}</Badge>) : null

                      ),
                      id: "QUESTIONS",
                      content: (
                        questions && (
                          <>
                            <SpaceBetween size="s" direction='vertical'>
                              <Header actions={
                                poll.questions.length > 0 && (
                                  <Button
                                    disabled={poll.idPoll === 0 || poll.hasEnded === 1 || (poll.answers && poll.answers.length > 0)}
                                    onClick={
                                      () => {
                                        const newQuestion: ItemPollQuestion = {
                                          idPoll: poll.idPoll,
                                          idQuestion: 0,
                                          question: '',
                                          expanded: false,
                                          questionType: 'TEXT',
                                          answer: { idAnswer: 0, answer: null, visibilityAnswer: 1 },
                                          questionParameters: {
                                            options: [],
                                            optionsRequired: 0,
                                            required: 0,
                                            minLength: 0,
                                            maxLength: 0
                                          },
                                          description: '',
                                          questionOrder: poll.questions.length + 1,
                                          index: poll.questions.length + 1,
                                          visibilityQuestion: 1

                                        };
                                        setQuestion(newQuestion);
                                      }}><Icon path={mdiPlus} size={1} /> Agregar pregunta</Button>
                                )}
                              />
                              {poll.questions.length === 0 && (
                                <Box
                                  margin={{ vertical: "xs" }}
                                  textAlign="center"
                                  color="inherit"
                                >
                                  <SpaceBetween direction='vertical' size='xs'>
                                    <b>Sin preguntas asignadas</b>

                                    {poll.idPoll === 0 && (
                                      <StatusIndicator type="warning">Registro no inicializado, no se pueden agregar preguntas hasta guardar el registro incial</StatusIndicator>

                                    )}

                                    <Button
                                      disabled={poll.idPoll === 0 || poll.hasEnded === 1 || (poll.answers && poll.answers.length > 0)}
                                      onClick={
                                        () => {
                                          const newQuestion: ItemPollQuestion = {
                                            idPoll: poll.idPoll,
                                            idQuestion: 0,
                                            question: '',
                                            expanded: false,
                                            questionType: 'TEXT',
                                            answer: { idAnswer: 0, answer: null, visibilityAnswer: 1 },
                                            questionParameters: {
                                              options: [],
                                              optionsRequired: 0,
                                              required: 0,
                                              minLength: 0,
                                              maxLength: 0
                                            },
                                            description: '',
                                            questionOrder: poll.questions.length + 1,
                                            index: poll.questions.length + 1,
                                            visibilityQuestion: 1

                                          };
                                          setQuestion(newQuestion);
                                        }}><Icon path={mdiPlus} size={1} /> Agregar pregunta</Button>
                                  </SpaceBetween>
                                </Box>
                              )}
                              {poll.questions && (
                                <List
                                  disableItemPaddings
                                  disablePaddings
                                  //sortable={poll.questions.every((q) => q.expanded === false)}
                                  ariaLabel="Lista de preguntas"
                                  items={poll.questions.map((q: ItemPollQuestion, index: number) => ({
                                    id: q.idQuestion.toString(),
                                    content: (
                                      <>
                                        <ExpandableSection
                                          variant="container"
                                          headerInfo={<Link variant='info'>{q.questionType === "TEXT"
                                            ? "Texto"
                                            : q.questionType === "OPTION"
                                              ? "Opciones"
                                              : "Numérico"}</Link>}

                                          headerActions={
                                            <SpaceBetween direction='horizontal' size='xs'>

                                              <Link onClick={() => {
                                                !(poll.hasEnded === 1 || (poll.answers && poll.answers.length > 0)) ? setQuestion(q) : null
                                              }}><Icon path={mdiNoteEditOutline} size={1} color='black' /></Link>

                                              <Link onClick={() => {
                                                !(poll.hasEnded === 1 || (poll.answers && poll.answers.length > 0)) ? setDeleteQuestion(q) : null
                                              }}><Icon path={mdiDeleteOutline} size={1} color='red' /></Link>
                                            </SpaceBetween>
                                          }
                                          headerText={
                                            <span>
                                              <Icon path={mdiProgressQuestion} size={1} />
                                              {` ${index + 1} `}
                                              {q.question.length > 35 ? q.question.substring(0, 35) + "…" : q.question}
                                            </span>
                                          }>
                                          <SpaceBetween size="s" direction='vertical'>
                                            <SpaceBetween size="s" direction='horizontal'>


                                              <FormField label={"Adicional"}>
                                                {q.description === "" ? <em>Sin definir</em> : q.description}
                                              </FormField>

                                              <FormField label={"Respuesta obligatoria"}>
                                                {q.questionParameters.required === 1 ? "Obligatoria" : "Opcional"}
                                              </FormField>

                                            </SpaceBetween>

                                            <FormField label="Visibilidad" constraintText="Define quién puede ver la respuesta del usuario en la inscripción">
                                              {q.visibilityQuestion == 1 ? "Público" : q.visibilityQuestion == -1 ? "Privado" : "Usuario decide"}
                                            </FormField>
                                            {q.questionType === "TEXT" && (
                                              <>
                                                <SpaceBetween size="s" direction='horizontal'>
                                                  <FormField label={"Mínimo caracteres"} constraintText="0 => Ilimitado">
                                                    {q.questionParameters.minLength?.toString()} caracteres
                                                  </FormField>
                                                  <FormField label={"Máximo caracteres"} constraintText="0 => Ilimitado">
                                                    {q.questionParameters.maxLength?.toString()} caracteres
                                                  </FormField>
                                                </SpaceBetween>
                                              </>
                                            )}

                                            {q.questionType === "NUMBER" && (
                                              <>
                                                <SpaceBetween size="s" direction='horizontal'>
                                                  <FormField label={"Rango inferior"} constraintText="0 => Ilimitado">
                                                    {q.questionParameters.minLength?.toString()}
                                                  </FormField>
                                                  <FormField label={"Rango superior"} constraintText="0 => Ilimitado">
                                                    {q.questionParameters.maxLength?.toString()}
                                                  </FormField>
                                                </SpaceBetween>
                                              </>
                                            )}
                                            {q.questionType === "OPTION" && (
                                              <>

                                                <SpaceBetween size="s" direction='horizontal'>
                                                  {q.questionParameters.required === 1 && (
                                                    <FormField label={"Mínimo de opciones seleccionadas"}>
                                                      {q.questionParameters.minLength} {q.questionParameters.minLength === 1 ? "opción" : "opciones"}
                                                    </FormField>
                                                  )}
                                                  <FormField label={"Máximo de opciones seleccionadas"}>
                                                    {q.questionParameters.maxLength} {q.questionParameters.maxLength === 1 ? "opción" : "opciones"}
                                                  </FormField>
                                                </SpaceBetween>
                                                {q && q.questionParameters && (
                                                  <List
                                                    items={q.questionParameters?.options?.map((opt, index) => ({
                                                      secondaryContent: `Opción #${index + 1}`,
                                                      content: opt.label,
                                                      id: index.toString()
                                                    })) || []}

                                                    renderItem={({ id, content, secondaryContent }) => ({
                                                      id,
                                                      content: (
                                                        <strong>
                                                          {content}
                                                        </strong>
                                                      ),
                                                      secondaryContent: (
                                                        <Box variant="small">{secondaryContent}</Box>
                                                      )
                                                    })}
                                                  />
                                                )}
                                              </>


                                            )}
                                          </SpaceBetween>

                                        </ExpandableSection>
                                        <Spacer height="20px" />
                                      </>
                                    )
                                  }))}
                                  renderItem={item => item}
                                />
                              )}
                            </SpaceBetween>
                          </>
                        )
                      ),
                    },
                    {
                      label: "Ordenamiento",
                      disabled: poll.questions.length <=

                        1,
                      id: "ORDER",
                      content: (
                        questions && (
                          <>
                            <SpaceBetween size="s" direction='vertical'>

                              {poll.questions.length === 0 && (
                                <Box
                                  margin={{ vertical: "xs" }}
                                  textAlign="center"
                                  color="inherit"
                                >
                                  <b>Sin preguntas asignadas</b>
                                </Box>
                              )}
                              {poll.questions && (
                                <List
                                  sortDisabled={pollIsDisableEdit}
                                  disableItemPaddings
                                  disablePaddings
                                  sortable
                                  ariaLabel="Lista de preguntas"
                                  items={poll.questions.map((q: ItemPollQuestion, index: number) => ({
                                    id: q.idQuestion.toString(),
                                    content: (
                                      <Box padding="s">
                                        {`Pregunta #${index + 1} ` + (q.question.length > 35 ? q.question.substring(0, 35) + "…" : q.question)}
                                      </Box>
                                    )
                                  }))}
                                  renderItem={item => item}
                                  onSortingChange={(event) => {
                                    setPoll((prev) => {
                                      if (!prev) return prev;
                                      const updatedQuestions = event.detail.items.map((sortedItem, index) => {
                                        const originalQuestion = prev.questions.find(q => q.idQuestion.toString() === sortedItem.id);
                                        return originalQuestion ? { ...originalQuestion, questionOrder: index + 1 } : null;
                                      }).filter(q => q !== null) as ItemPollQuestion[];


                                      const nextPoll = {
                                        idPoll: poll.idPoll,
                                        questions: updatedQuestions
                                      };
                                      handleUpdatePollManual(nextPoll, true);

                                      return { ...prev, questions: updatedQuestions };
                                    });
                                  }}
                                />
                              )}
                            </SpaceBetween>
                          </>
                        )
                      )
                    },
                  ]}
                />
              </SpaceBetween>

            </>
          )
          }
          {
            !!question && (
              <Modal visible={!!question} onDismiss={() => setQuestion(undefined)} header={question.idQuestion === 0 ? "Agregar pregunta" : "Actualizar pregunta"}
                footer={<Box>
                  <Box float='left'><Button onClick={() => setQuestion(undefined)} variant="link">Cancelar</Button></Box>
                  <Box float='right'>
                    <Button
                      onClick={() => {
                        handleAddQuestion(question)
                      }}
                      variant="primary">{question.idQuestion === 0 ? "Agregar" : "Actualizar"}</Button></Box>
                </Box>}
              >

                <>
                  <ExpandableSection expanded
                    headerText={`Pregunta #${question.questionOrder}`}  >
                    <SpaceBetween size="s" direction='vertical'>
                      <div style={{ width: 500 }}>
                        <FormField label={`Pregunta`} stretch>
                          <Input
                            value={question.question}
                            onChange={(e) => {
                              setQuestion(prev => ({ ...prev, question: e.detail.value }))
                            }}
                          />
                        </FormField>
                      </div>


                      <FormField label={"Información adicional"}>
                        <Input value={question.description}
                          onChange={(e) => {
                            setQuestion(prev => ({ ...prev, description: e.detail.value }))
                          }} />
                      </FormField>
                      <SpaceBetween direction='horizontal' size='xs'>
                        <FormField label={`Tipo de pregunta`} stretch={false}>
                          <Select
                            selectedOption={{
                              label:
                                question.questionType === "TEXT"
                                  ? "Texto"
                                  : question.questionType === "OPTION"
                                    ? "Opciones"
                                    : "Numérico",
                              value: question.questionType
                            }}
                            onChange={({ detail }) => {
                              const newType = detail.selectedOption?.value ?? "TEXT"; // ✅ Default value ensures string
                              setQuestion(prev => ({ ...prev, questionType: newType }))
                            }}
                            options={[
                              { label: "Texto", value: "TEXT" },
                              { label: "Opciones", value: "OPTION" },
                              { label: "Numérico", value: "NUMBER" },
                            ]}
                            placeholder="Tipo de pregunta"
                          />
                        </FormField>

                        <FormField label={`Obligatoriedad`} stretch={false}>
                          <Checkbox description="Respuesta obligatoria" checked={question.questionParameters.required === 1} onChange={(e) => {
                            const isChecked = e.detail.checked ? 1 : 0;
                            setQuestion((prev) => {
                              if (!prev) return prev;
                              return {
                                ...prev,
                                // Update the nested parameters object
                                questionParameters: {
                                  ...prev.questionParameters,
                                  required: isChecked,
                                  minLength: isChecked ? (prev.questionParameters?.minLength || 0) : 0
                                }
                              };
                            });


                          }} />
                        </FormField>
                      </SpaceBetween>

                      <FormField label="Visibilidad" constraintText="Define quién puede ver la respuesta del usuario en la inscripción">
                        <RadioGroup
                          direction='horizontal'
                          value={question.visibilityQuestion.toString()}
                          onChange={(e) => {
                            setQuestion(prev => {
                              if (!prev) return prev;
                              return {
                                ...prev,
                                visibilityQuestion: parseInt(e.detail.value)
                              };
                            });
                          }}
                          items={[
                            { value: "1", label: "Público" },
                            { value: "-1", label: "Privado" },
                            { value: "0", label: "Usuario decide" },
                          ]} />
                      </FormField>
                      {question.questionType === "TEXT" && (
                        <>
                          <SpaceBetween size="s" direction='horizontal'>
                            <FormField label={"Mínimo caracteres"} constraintText="0 => Ilimitado">
                              <Input type='number' value={question.questionParameters.minLength?.toString()} onChange={(e) => {
                                setQuestion(prev => ({
                                  ...prev,
                                  questionParameters: { ...prev.questionParameters, minLength: Number(e.detail.value) }
                                }))

                              }} />
                            </FormField>
                            <FormField label={"Máximo caracteres"} constraintText="0 => Ilimitado">
                              <Input type='number' value={question.questionParameters.maxLength?.toString()} onChange={(e) => {
                                setQuestion(prev => ({
                                  ...prev,
                                  questionParameters: { ...prev.questionParameters, maxLength: Number(e.detail.value) }
                                }))
                              }} />
                            </FormField>

                          </SpaceBetween>
                        </>
                      )}

                      {question.questionType === "NUMBER" && (
                        <>
                          <SpaceBetween size="s" direction='horizontal'>
                            <FormField label={"Rango inferior"} constraintText="0 => Ilimitado">
                              <Input type='number' value={question.questionParameters.minLength?.toString()} onChange={(e) => {
                                setQuestion(prev => ({
                                  ...prev,
                                  questionParameters: { ...prev.questionParameters, minLength: Number(e.detail.value) }
                                }))
                              }}
                              />
                            </FormField>
                            <FormField label={"Rango superior"} constraintText="0 => Ilimitado">
                              <Input type='number' value={question.questionParameters.maxLength?.toString()} onChange={(e) => {

                                setQuestion(prev => ({
                                  ...prev,
                                  questionParameters: { ...prev.questionParameters, maxLength: Number(e.detail.value) }
                                }))
                              }} />
                            </FormField>

                          </SpaceBetween>
                        </>
                      )}
                      {question.questionType === "OPTION" && (
                        <>

                          <SpaceBetween size="s" direction='horizontal'>
                            {question.questionParameters.required === 1 && (
                              <FormField label={"Mínimo de opciones seleccionadas"}>
                                <Select
                                  selectedOption={
                                    question.questionParameters.minLength
                                      ? {
                                        label: question.questionParameters.minLength.toString(),
                                        value: question.questionParameters.minLength.toString(),
                                      }
                                      : null
                                  }
                                  onChange={(e) => {
                                    setQuestion(prev => ({
                                      ...prev,
                                      questionParameters: { ...prev.questionParameters, minLength: Number(e.detail.selectedOption.value) }
                                    }))
                                  }}
                                  options={Array.from({ length: question.questionParameters.options.length }, (_, i) => ({ label: (i + 1).toString(), value: (i + (question.questionParameters.required ? 1 : 0)).toString(), })
                                  )}
                                />
                              </FormField>
                            )}
                            <FormField label={"Máximo de opciones seleccionadas"}>
                              <Select
                                selectedOption={
                                  question.questionParameters.maxLength
                                    ? {
                                      label: question.questionParameters.maxLength.toString(),
                                      value: question.questionParameters.maxLength.toString(),
                                    }
                                    : null
                                }
                                onChange={(e) => {

                                  setQuestion(prev => ({
                                    ...prev,
                                    questionParameters: { ...prev.questionParameters, maxLength: Number(e.detail.selectedOption.value) }
                                  }))
                                }}
                                options={Array.from({ length: question.questionParameters.options.length }, (_, i) => ({ label: (i + 1).toString(), value: (i + 1).toString(), })
                                )}
                              />
                            </FormField>
                          </SpaceBetween>
                          {question.questionParameters.options.map((opt, index) => (
                            <FormField label={`Opción #${index + 1}`} key={index} constraintText={
                              index > 0 && (<Link variant="info"
                                onClick={(e) => {
                                  setQuestion((prev) => {
                                    if (!prev) return prev;
                                    const updatedOptions = prev.questionParameters.options.filter((_, i) => i !== index);
                                    return {
                                      ...prev,
                                      questionParameters: {
                                        ...prev.questionParameters,
                                        options: updatedOptions,
                                      },
                                    };
                                  });
                                }}>Eliminar opción <Icon path={mdiArrowUpRightBold} size={0.6} /></Link>)
                            }>
                              <Input
                                value={opt.label}
                                onChange={(e) => {
                                  setQuestion((prev) => {
                                    if (!prev) return prev;
                                    const updatedOptions = prev.questionParameters.options.map((o, i) =>
                                      i === index ? { ...o, label: e.detail.value, value: e.detail.value } : o
                                    );
                                    return {
                                      ...prev,
                                      questionParameters: {
                                        ...prev.questionParameters,
                                        options: updatedOptions,
                                      },
                                    };
                                  });
                                }}
                              />
                            </FormField>
                          ))}
                          <Button onClick={() => {
                            setQuestion((prev) => {
                              if (!prev) return prev;
                              const newOption = { label: '', value: '' };
                              return {
                                ...prev,
                                questionParameters: {
                                  ...prev.questionParameters,
                                  options: [...(prev.questionParameters?.options || []), newOption],
                                },
                              };
                            });
                          }}><Icon path={mdiPlus} size={1} /> Agregar opción</Button>
                        </>


                      )}
                    </SpaceBetween>

                  </ExpandableSection>
                  <Spacer height="20px" />
                </>

              </Modal>

            )
          }
          {
            deleteQuestion && (
              <Modal visible={!!deleteQuestion} onDismiss={() => setDeleteQuestion(undefined)}
                header={"Eliminar pregunta"}
                footer={<Box>
                  <Box float='left'><Button variant='link' onClick={() => setDeleteQuestion(undefined)}>Cancelar</Button></Box>
                  <Box float='right'><Button style={{ root: btnDanger }} onClick={() =>
                    handleDeleteQuestion(deleteQuestion.idQuestion)
                  }>Eliminar</Button></Box>
                </Box>}
              >
                <Box>
                  ¿Está seguro de querer eliminar la pregunta <em>{deleteQuestion.question}</em>
                </Box>

              </Modal>
            )
          }
          <ConfirmDelete show={!!pollDelete} confirmWord={'eliminar'} action={'Eliminar'} warning={'Por favor confirme la eliminación de la inscripción, preguntas y respuestas en caso de existir'} header='Eliminar inscripción' onConfirm={() => {
            handlePollDelete();
          }}
            onDismiss={() => setPollDelete(undefined)}
          />
        </SpaceBetween >
      }
    />
  );
};
